import { useNavigateToHome, useToastError } from '@/hooks';
import Button from '@/storybook/components/Button/Button';
import Text from '@/storybook/components/Text/Text';
import { FallbackProps, useErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Footer } from '../../components/base';
import ApplicationHeader from '../../components/base/Header/components/ApplicationHeader/ApplicationHeader';
import styles from './ErrorFallback.module.scss';
import ErrorImage from './ErrorImage/ErrorImage';

const ErrorFallback = ({ error }: FallbackProps) => {
  const { resetBoundary } = useErrorBoundary();
  const { t } = useTranslation();
  const navigateToHome = useNavigateToHome();

  useToastError(error);

  const reset = (stayOnPage = false) => {
    resetBoundary();
    if (!stayOnPage) {
      navigateToHome();
    }
  };

  return (
    <div className={styles.error}>
      <ApplicationHeader />
      <div className={styles.message}>
        <ErrorImage width={150} height={150} />
        <Text as="h2">{t('main.error.errorOccurred')}</Text>
        <Text as="p">{t('main.error.tryAgainOrGoBack')}</Text>
        <div className={styles.buttonsWrapper}>
          <Button variant="outlined" onClick={() => reset()}>
            {t('main.error.backToHomepage')}
          </Button>
          <Button onClick={() => reset(true)}>{t('main.error.tryAgain')}</Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ErrorFallback;
